import { render, staticRenderFns } from "./article_detail.vue?vue&type=template&id=baf8ef2a&"
import script from "./article_detail.vue?vue&type=script&lang=js&"
export * from "./article_detail.vue?vue&type=script&lang=js&"
import style0 from "./article_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports